import { render, staticRenderFns } from "./app-fab.vue?vue&type=template&id=84fc912a&"
import script from "./app-fab.vue?vue&type=script&lang=js&"
export * from "./app-fab.vue?vue&type=script&lang=js&"
import style0 from "./app-fab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports